import React from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  Button,
  Checkbox,
  Typography,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  CircularProgress
} from '@material-ui/core'
import styled from 'styled-components'
import { connect } from 'react-redux'
import Fade from '@material-ui/core/Fade'
import Tooltip from '@material-ui/core/Tooltip'
import { colors, theme } from '../../theme/Global'
import { emailNotificationPost, emailNotificationDismiss } from '../../common/actions'

const EmailInput = styled(TextField)`
  && {
    width: 200px;
    background-color: ${theme.colors.background};
    margin: 12px 30px 12px 0;
    label {
      color: ${colors.white};
      top: -16px;
      padding-left: 10px;
      font-size: 14px;
    }
    div {
      margin-top: 0px;
    }
    input {
      color: ${colors.white};
      padding: 11px 12px;
    }
  }
`

const StyledLabel = styled(FormLabel)`
  && {
    font-size: 14px;
    margin: 20px 136px 0 0;
    color: ${theme.colors.background} !important;
  }
`

const Form = styled.form`
  text-align: center;
  color: ${colors.white};
  padding: 20px 0;
  span {
    color: rgb(120, 120, 120) !important;
  }
  svg {
    color: ${colors.white};
  }
`
const Submit = styled(Button)`
  && {
    background-color: ${colors.govDocsRed};
    height: 36px;
    margin: 10px;
    span {
      color: ${colors.white} !important;
    }
  }
  &&:disabled {
    background-color: ${theme.colors.background};
    opacity: 0.6;
  }
`

const Dismiss = styled.button`
  && {
    background: transparent;
    border: none;
    color: rgb(120, 120, 120);
    font-size: 12px;
    cursor: pointer;
  }
`

const StyledCheckbox = styled(Checkbox)`
  opacity : ${(props) => ((props.disabled) ? '0.6' : 'inherit')};
  &&:disabled {
    background-color: ${theme.colors.background};
    opacity: 0.6;
  }
`
class EmailNotificationComponent extends React.Component {
  state = {
    loading: false,
    frequency: ['30', '60', '90'],
  };

  handleChange = (event) => {
    if (this.state.frequency.indexOf(event.target.value) === -1) {
      this.setState({
        frequency: [...this.state.frequency, event.target.value],
      })
    } else {
      const filteredArray = this.state.frequency.filter((item) => item !== event.target.value)
      this.setState({
        frequency: filteredArray,
      })
    }
  };

  dismiss = () => {
    const data = { userId: this.props.userId, value: 'email_notifications' }
    this.props.emailNotificationDismiss(data)
  }

  save = () => {
    const data = { userId: this.props.userId, value: this.state.frequency.join() }
    this.props.emailNotificationPost(data)
    this.setState({
      loading: true,
    })
  }

  render() {
    return (
      <div>
        <Form>
          <Typography variant="title" style={{ color: theme.colors.whiteText }} gutterBottom>Wage notifications via email now available</Typography>
          <FormControl component="fieldset">
            <FormGroup row>
              <StyledLabel component="legend">Email to notify</StyledLabel>
              <StyledLabel component="legend">Frequency</StyledLabel>
            </FormGroup>
            <FormGroup row>
              <EmailInput
                disabled
                id="filled-disabled"
                value={this.props.email}
                margin="normal"
                variant="filled"
              />
              <FormControlLabel
                control={
                  <StyledCheckbox disabled={this.state.loading} checked={this.state.frequency.includes('90')} onChange={this.handleChange} value="90" />
                }
                label="90 Days"
              />
              <FormControlLabel
                control={
                  <StyledCheckbox disabled={this.state.loading} checked={this.state.frequency.includes('60')} onChange={this.handleChange} value="60" />
                }
                label="60 Days"
              />
              <Tooltip
                TransitionComponent={Fade}
                placement="bottom"
                title="To be notified of recent wage changes, all users will receive a 30 day notification."
              >
                <FormControlLabel
                  control={
                    <StyledCheckbox disabled checked value="30" />
                  }
                  label="30 Days"
                />
              </Tooltip>
              <Submit onClick={this.save} disabled={this.state.frequency.length === 0 || this.state.loading}>
                {this.state.loading && <CircularProgress size={24} style={{ marginRight: '10px' }} />} Subscribe
              </Submit>
            </FormGroup>
          </FormControl>
        </Form>
        <p style={{ marginTop: '0px', textAlign: 'center' }}><Dismiss onClick={this.dismiss}>Don't show this again</Dismiss></p>
      </div>
    )
  }
}

EmailNotificationComponent.propTypes = {
  email: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => ({
  userId: state.account.user.id,
  email: state.account.user.email,
})

export default connect(
  mapStateToProps,
  { emailNotificationPost, emailNotificationDismiss }
)(EmailNotificationComponent)
